import React, { useCallback, useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Loader } from '../util/Loader';
import { useErrorHandling } from '../hooks/useErrorHandling';
import projectClaimTemplateCategoriesService from '../services/project_report/project_claim_template_categories.service';
import claimProjectReportsListsService from '@rd-web-markets/shared/dist/services/lists/claim_groups/claim_project_reports_lists.service';
import { ClaimState } from '../claim';
export default function ProjectTaskState(_ref) {
  let {
    accountType,
    claimGroup,
    handleToaster
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = claimProjectReportsListsService.useFetchAll({
    setLoading,
    claimGroupId: claimGroup.id
  });
  const [currentProject, setCurrentProject] = useState(null);
  const onProjectChange = event => {
    const project = projects.find(p => p.id === Number(event.target.value));
    setCurrentProject(project);
  };
  const markProjectTaskComplete = useErrorHandling(useCallback(async (category, categoryIndex, taskIndex, claimGroup) => {
    //project task
    const response = await projectClaimTemplateCategoriesService.update(currentProject.id, category, categoryIndex, taskIndex);
    const reportIndex = projects.findIndex(cpr => cpr.id === currentProject.id);
    projects[reportIndex].tasks = [...response.tasks];
    setProjects([...projects]);
    handleToaster('Task Updated!');
  }, [currentProject, handleToaster, projects, setProjects]));
  useEffect(() => {
    if (projects.length && !currentProject) {
      setCurrentProject(projects[0]);
    }
  }, [claimGroup, currentProject, projects]);
  if (!claimGroup || projects === null) {
    console.log('returning loader');
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (!projects.length || !projects[0].tasks?.length) {
    console.log('returning NONE: ', !projects.length, !projects[0]?.tasks?.length);
    console.log(projects[0]);
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 1
  }, /*#__PURE__*/React.createElement("strong", null, "Project")), /*#__PURE__*/React.createElement(Col, {
    md: 11
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    onChange: onProjectChange,
    size: "md"
  }, projects.map((project, index) => /*#__PURE__*/React.createElement("option", {
    value: project.id
  }, project.project_name))))), currentProject && /*#__PURE__*/React.createElement(ClaimState, {
    tasks: currentProject.tasks,
    markTaskComplete: markProjectTaskComplete,
    claimGroup: claimGroup
  }));
}